import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

const AiChatMessageIconButton = ({
    icon,
    label,
    title,
    actionName,
    onClick,
    disabled = false,
    isHighlighted = false,
}) => (
    <button
        type='button'
        onClick={onClick}
        disabled={disabled}
        title={title ?? label}
        aria-label={label}
        data-dd-action-name={actionName}
        className={clsx(
            'w-fit cursor-pointer rounded-lg border px-2 py-1 text-[13px] leading-none transition-all disabled:cursor-not-allowed disabled:opacity-50',
            isHighlighted ? 'border-lime-300 bg-lime-100' : 'border-gray-200 bg-gray-50'
        )}
    >
        <FontAwesomeIcon
            icon={icon}
            className={isHighlighted ? 'text-lime-600' : 'text-gray-500'}
        />
    </button>
);

export { AiChatMessageIconButton };
